<template>
<div class="MStepOne">
    <div class="content_warp">
        <div class="card">
            <p class="p_title">估值用途</p>
            <!-- <div @click="activeCardOne = item.id" class="card_item" :class="activeCardOne === item.id ? 'active' : ''" v-for="(item, index) in cardOne" :key="index">{{item.text}}</div> -->
            <div @click="activeCardOne = item.id" class="card_item" :class="{'card_item': true, 'active': activeCardOne === item.id}" v-for="(item, index) in cardOne" :key="index">{{item.text}}</div>
        </div>
        <div class="card">
            <p class="p_title">所属行业</p>
            <div @click="activeCardTwo = item.id" class="card_item" :class="{'card_item': true, 'active': activeCardTwo === item.id}" v-for="(item, index) in cardTwo" :key="index">{{item.text}}</div>
        </div>
        <div class="card">
            <p class="p_title">发展阶段</p>
            <div @click="activeCardThree = item.id" class="card_item" :class="{'card_item': true, 'active': activeCardThree === item.id}" v-for="(item, index) in cardThree" :key="index">{{item.text}}</div>
        </div>
    </div>
    <!-- <div @click="nextStepClick" v-if="activeCardOne === '' || activeCardTwo === '' || activeCardThree ===''" class="btn_box disable_btn">下一步</div>
    <div @click="nextStepClick" v-else class="btn_box">下一步</div> -->
    <div @click="nextStepClick" :class="{'btn_box': true, 'disable_btn': activeCardOne === '' || activeCardTwo === '' || activeCardThree ===''}">下一步</div>
</div>
</template>

<script>
import {getEvArithmetic} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
import {Toast} from 'vant'
import $ from 'jquery'
export default {
    name: 'MStepOne',
    data() {
        return {
            cardOne: [
                {id:1, text: '股权激励'},
                {id:2, text: '股权融资'},
                {id:3, text: '企业并购'}
            ],
            cardTwo: [
                {id:1, text: '互联网新经济'},
                {id:2, text: '重资产'},
                {id:3, text: '轻资产'}
            ],
            cardThree: [
                {id:1, text: '初创期'},
                {id:2, text: '成长期'},
                {id:3, text: '成熟期'}
            ],
            activeCardOne: '',  // 企业估值用途  选中列表
            activeCardTwo: '',  // 企业所属行业  选中列表
            activeCardThree: '',  // 企业发展阶段   选中列表
        }
    },
    mounted() {
        $('html').scrollTop(0)
    },
    methods: {
        // 点击下一步
        nextStepClick() {
            if (this.activeCardOne === '') {
                Toast('请选择估值用途')
            } else if (this.activeCardTwo === '') {
                Toast('请选择所属行业')
            } else if (this.activeCardThree === '') {
                Toast('请选择发展阶段')
            } else {
                this.findEvArithmetic()
            }
        },
        findEvArithmetic() {
            this.setLoading(true)
            let params = {
                evuseagetype: this.activeCardOne,
                evindustrytype: this.activeCardTwo,
                evphasetype: this.activeCardThree
            }
            getEvArithmetic({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    if (data) {
                        this.$emit('setStepData', data.data.content, params)
                        this.$emit('setStepValue', 1)
                    }
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.MStepOne {
    padding-bottom: 0.8rem;
    .content_warp {
        padding: 0.32rem;
        background-color: #fff;
        .card {
            .p_title {
                border-left: 0.03rem solid #409EFF;
                padding-left: 0.12rem;
                line-height: 0.32rem;
                font-size: 0.32rem;
            }
            .card_item {
                font-size: 0.32rem;
                margin-top: 0.32rem;
                height: 0.7rem;
                line-height: 0.7rem;
                text-align: center;
                // box-sizing: border-box;
                border: 0.01rem solid #409EFF;
                color: #409EFF;
            }
            .card_item.active {
                background-color: #409EFF;
                color: #FFF;
            }
    
        }
        .card + .card{
            margin-top: 0.32rem;
        }
    }
    .btn_box {
        font-size: 0.32rem;
        width: 100vw;
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: center;
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #409EFF;
        color: #FFF;
    }
    .disable_btn {
        background-color: #94C2F1;
    }
}
</style>